(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../../../elements', '../flowtypes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../../../elements'), require('../flowtypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.elements, global.flowtypes);
    global.ValidationErrors = mod.exports;
  }
})(this, function (exports, _react, _elements, _flowtypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Paragraph = _elements.typography.Paragraph;


  var ValidationErrors = function ValidationErrors(_ref) {
    var errors = _ref.errors;
    return errors.map(function (error, i) {
      return _react2.default.createElement(
        'div',
        { key: 'error' + (i + 0) },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            Paragraph,
            { color: 'dragon' },
            error.errorType,
            ':'
          )
        ),
        error.errorMessages.map(function (message, j) {
          return _react2.default.createElement(
            'div',
            { key: 'errorMessage' + (j + 0) },
            _react2.default.createElement(
              Paragraph,
              { muted: true },
              message
            )
          );
        })
      );
    });
  };

  exports.default = ValidationErrors;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/ValidationErrors.js
// module id = 2041
// module chunks = 1